export const lightTheme = {
  // Backgrounds
  bg: '#f5f5f7',
  bgCard: '#ffffff',
  bgHeader: '#ffffff',
  bgSidebar: '#ffffff',
  bgInput: '#f9fafb',
  bgHover: '#f0f0f5',
  bgSelected: '#eef2ff',
  bgDescription: '#eef2ff',
  bgFooter: 'rgba(255,255,255,0.85)',
  bgModal: '#ffffff',
  bgOverlay: 'rgba(0,0,0,0.4)',
  bgTag: '#f1f5f9',
  bgInfo: '#f1f5f9',
  bgRequired: '#fef3c7',
  textRequired: '#b45309',

  // Text
  text: '#1e293b',
  textSecondary: '#64748b',
  textMuted: '#94a3b8',
  textInverse: '#ffffff',
  textPrice: '#1e293b',

  // Accent (Indigo)
  accent: '#4F46E5',
  accentHover: '#4338CA',
  accentLight: '#eef2ff',
  accentText: '#4F46E5',

  // Borders
  border: '#e2e8f0',
  borderSelected: '#4F46E5',
  borderCard: '#e2e8f0',
  borderInput: '#d1d5db',
  borderInputFocus: '#4F46E5',

  // Shadows
  shadow: '0 1px 3px rgba(0,0,0,0.08)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
  shadowLg: '0 8px 30px rgba(0,0,0,0.12)',
  shadowCard: '0 1px 3px rgba(0,0,0,0.06)',
  shadowCardHover: '0 4px 16px rgba(0,0,0,0.1)',

  // Status
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',

  // Misc
  radius: '12px',
  radiusSm: '8px',
  radiusLg: '16px',
  transition: 'all 0.2s ease',
};

export const darkTheme = {
  // Backgrounds
  bg: '#0f172a',
  bgCard: '#1e293b',
  bgHeader: '#1e293b',
  bgSidebar: '#1e293b',
  bgInput: '#334155',
  bgHover: '#334155',
  bgSelected: '#312e81',
  bgDescription: '#1e1b4b',
  bgFooter: 'rgba(15,23,42,0.9)',
  bgModal: '#1e293b',
  bgOverlay: 'rgba(0,0,0,0.6)',
  bgTag: '#334155',
  bgInfo: '#334155',
  bgRequired: '#451a03',
  textRequired: '#fbbf24',

  // Text
  text: '#e2e8f0',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  textInverse: '#ffffff',
  textPrice: '#e2e8f0',

  // Accent (Indigo)
  accent: '#6366f1',
  accentHover: '#818cf8',
  accentLight: '#312e81',
  accentText: '#a5b4fc',

  // Borders
  border: '#334155',
  borderSelected: '#6366f1',
  borderCard: '#334155',
  borderInput: '#475569',
  borderInputFocus: '#6366f1',

  // Shadows
  shadow: '0 1px 3px rgba(0,0,0,0.3)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.3)',
  shadowLg: '0 8px 30px rgba(0,0,0,0.4)',
  shadowCard: '0 1px 3px rgba(0,0,0,0.2)',
  shadowCardHover: '0 4px 16px rgba(0,0,0,0.3)',

  // Status
  success: '#34d399',
  error: '#f87171',
  warning: '#fbbf24',

  // Misc
  radius: '12px',
  radiusSm: '8px',
  radiusLg: '16px',
  transition: 'all 0.2s ease',
};
